import { render, staticRenderFns } from "./dash.vue?vue&type=template&id=0c5e6b61&scoped=true"
import script from "./dash.vue?vue&type=script&lang=ts"
export * from "./dash.vue?vue&type=script&lang=ts"
import style0 from "./dash.vue?vue&type=style&index=0&id=0c5e6b61&prod&lang=scss&scoped=true"
import style1 from "./dash.vue?vue&type=style&index=1&id=0c5e6b61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e6b61",
  null
  
)

export default component.exports